// Guards persisted tool results (metadata comes from the DB), so the schema
// check must be a safeParse, never a throw.
export const makeBuiltInToolResultGuard = (toolName, metadataSchema) => (result) => result.toolType === 'built-in' &&
    result.toolName === toolName &&
    metadataSchema.safeParse(result.metadata).success;
//# sourceMappingURL=builtInToolResultGuard.js.map